import { addIntersectionItem } from '../util'

let activeClass

export default function init() {
    activeClass = 'scroll-active'

    setupScrollAnimation()
}

function setupScrollAnimation() {
    const scrollAnimationElements = document.querySelectorAll('.js-scroll-anim')
    const scrollAnimations = Array.from(scrollAnimationElements)

    const blockquoteAnimationElements = document.querySelectorAll('.typography blockquote')
    const blockquoteAnimations = Array.from(blockquoteAnimationElements)

    scrollAnimations.concat(blockquoteAnimations).forEach(el => {
        const options = {
            isActive: false
        }
        addIntersectionItem(el, handleIntersection, options)
    })
}

function handleIntersection(intersectionObj, entry) {
    const { el, options } = intersectionObj

    if (!entry.isIntersecting || entry.intersectionRatio < 0.2 || options.isActive) {
        return
    }

    el.classList.add(activeClass)
    options.isActive = true
}
